const PENDING_DOWNLOAD_KEY = 'developer-pending-download';

export const getPendingDownload = () => window.sessionStorage.getItem(PENDING_DOWNLOAD_KEY);

export const setPendingDownload = (path) =>
  window.sessionStorage.setItem(PENDING_DOWNLOAD_KEY, path);

export const clearPendingDownload = () => window.sessionStorage.removeItem(PENDING_DOWNLOAD_KEY);
